export default class RequestProcess {
	static fromJSON(json) {
		return new RequestProcess(json.id)
			.withProposedEstablishment(json.proposedEstablishment)
			.withReason(json.reason)
	}

	constructor(id) {
		this.id = id
	}

	withProposedEstablishment(proposedEstablishment) {
		this.proposedEstablishment = {
			id: proposedEstablishment?.id,
			name: proposedEstablishment?.name,
		}
		return this
	}

	withReason(reason) {
		this.reason = reason
		return this
	}
}
